export enum SidebarType {
  DOCUMENTATION = 'DOCUMENTATION',
  COMMENTS = 'COMMENTS',
  ASSISTANT = 'ASSISTANT',
  VALIDATION = 'VALIDATION',
  HISTORY = 'HISTORY'
}
